import { LayerProps } from "react-map-gl";
import { colors } from "shared/styles/constants";

export const markerLayer: LayerProps = {
  id: "markers",
  type: "symbol",
  source: "markers",
  layout: {
    "symbol-placement": "point",
    "icon-allow-overlap": true,
    "icon-image": "marker-icon",
    "icon-size": 0.6,
    "icon-anchor": "bottom",
  },
  paint: {
    "icon-color": colors.red,
  },
};

export const lineLayer: LayerProps = {
  id: "lines",
  type: "line",
  source: "lines",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-width": 3,
    "line-color": colors.grey4,
    "line-dasharray": [1, 2],
  },
};
